// 活跃订单类型定义
import type { PaginationParams } from '../data/types'
import { PaginatedList } from '../data/types'

// 活跃订单
export class ActiveOrder {
  id: string
  orderId: string
  nftContract: string
  tokenId: string
  depositor: string
  price: string
  status: number
  createdAt: string
  updatedAt?: string
  withdrawnAt?: string
  createdBlockNumber: string
  updatedBlockNumber?: string
  withdrawnBlockNumber?: string
  createdTransactionHash: string
  withdrawnTransactionHash?: string

  constructor(data: {
    id: string
    orderId: string
    nftContract: string
    tokenId: string
    depositor: string
    price: string
    status: number
    createdAt: string
    updatedAt?: string
    withdrawnAt?: string
    createdBlockNumber: string
    updatedBlockNumber?: string
    withdrawnBlockNumber?: string
    createdTransactionHash: string
    withdrawnTransactionHash?: string
  }) {
    this.id = data.id
    this.orderId = data.orderId
    this.nftContract = data.nftContract
    this.tokenId = data.tokenId
    this.depositor = data.depositor
    this.price = data.price
    this.status = data.status
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.withdrawnAt = data.withdrawnAt
    this.createdBlockNumber = data.createdBlockNumber
    this.updatedBlockNumber = data.updatedBlockNumber
    this.withdrawnBlockNumber = data.withdrawnBlockNumber
    this.createdTransactionHash = data.createdTransactionHash
    this.withdrawnTransactionHash = data.withdrawnTransactionHash
  }

  // 获取状态文本
  getStatusText(): string {
    switch (this.status) {
      case 0: return '已上架'
      case 1: return '已取消'
      case 3: return '已撤回'
      default: return '未知'
    }
  }

  // 获取格式化的价格（ETH）
  getFormattedPrice(): string {
    const price = BigInt(this.price)
    const ethPrice = Number(price) / 1e18
    return `${ethPrice.toFixed(6)} ETH`
  }
}

// 活跃订单查询参数
export interface GetActiveOrdersParams extends PaginationParams {
  nftContract?: string
  tokenId?: string
  depositor?: string
  status?: number
}

// 导出分页列表类型
export { PaginatedList } from '../data/types'

